function getServiceAdvisorPhone(mobilePhone, landlinePhone, repairShopPhone) {
  return mobilePhone || landlinePhone || repairShopPhone
}

export { getServiceAdvisorPhone }
